import { useQuery } from '@tanstack/react-query'

import { activityApi, creditsApi } from '@/api/endpoints'
import { queryKeys } from '@/api/queryKeys'

/** Sopra questa quota il saldo passa a stato critico e si fa notare. */
const CRITICAL_THRESHOLD = 0.85

export interface CreditsSummary {
  used: number
  included: number
  remaining: number
  ratio: number
  isCritical: boolean
  /** Lettura testuale per il misuratore: lo stato non è mai solo un colore. */
  valueText: string
}

export function useCredits() {
  const query = useQuery({
    queryKey: queryKeys.credits,
    queryFn: () => creditsApi.balance(),
  })

  const balance = query.data
  const summary: CreditsSummary | undefined = balance
    ? {
        used: balance.used,
        included: balance.included,
        remaining: balance.included - balance.used,
        ratio: balance.included > 0 ? balance.used / balance.included : 0,
        isCritical: balance.included > 0 && balance.used / balance.included >= CRITICAL_THRESHOLD,
        valueText: `${balance.used} crediti usati su ${balance.included}`,
      }
    : undefined

  return { ...query, summary }
}

export function useActivity() {
  return useQuery({
    queryKey: queryKeys.activity,
    queryFn: () => activityApi.list(),
  })
}
